import React from 'react';
import { Link } from 'react-router-dom';
import Singleton from '../core/singleton';

export default () => {
    const { getTradByKey } = Singleton.getInstance();
    const Cols = props => <div className="card-deck">
        {
            Object.keys(props.iterate).map(
                (key, index) => <div key={index} className="card border-light">
                    <div className="card-body">
                        <Link
                            title={props.iterate[key]}
                            className="btn btn-lg btn-block btn-outline-primary h-100 d-flex align-items-center justify-content-center"
                            to={`/${key}`}>
                            <h5 className="p-3 text-center">{props.iterate[key]}</h5>
                        </Link>
                    </div>
                </div>
            )
        }
    </div>
    /** return a col with some btns */
    const OnBoardSales = () => {
        let b = {
            inventory: getTradByKey('manage_inventory'),
            onboardsales: getTradByKey('manage_on_board_sales_service'),
            orders: getTradByKey('manage_orders')
        }
        return <Cols iterate={b} />
    }
    /** return a col with some btns */
    const OtherServices = () => {
        let b = {
            paxcall: getTradByKey('pax_calls'),
            ifehealth: getTradByKey('ife_health'),
            reports: getTradByKey('reports')
        }
        return <Cols iterate={b} />
    }
    return <div className="container-fluid HomePage">
        <div className="OnBoardSales mb-4">
            <h4 className="text-center text-md-right">{getTradByKey('on_board_sales')}</h4>
            <OnBoardSales />
        </div>
        <div className="OtherServices">
            <h4 className="text-center text-md-right">{getTradByKey('other_services')}</h4>
            <OtherServices />
        </div>
    </div>
}